"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NHSComplexCarePathway_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var NHSClaim_1 = require("./NHSClaim");
var NHSCourseDetail_1 = require("./NHSCourseDetail");
var NHSComplexCarePathway_Factory = /** @class */ (function () {
    function NHSComplexCarePathway_Factory() {
    }
    NHSComplexCarePathway_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ComplexCarepathwayType: model.ComplexCarepathwayType,
            ExpectedNumberOfClaims: model.ExpectedNumberOfClaims,
            IncompleteReasonCode: model.IncompleteReasonCode,
            LocationId: model.LocationId,
            NHSClaims: model.NHSClaims && model.NHSClaims.map(function (i) { return NHSClaim_1.NHSClaim_Factory.CreateIncoming(i); }),
            NHSCourseDetail: NHSCourseDetail_1.NHSCourseDetail_Factory.CreateIncoming(model.NHSCourseDetail),
            PatientId: model.PatientId,
            ProviderId: model.ProviderId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            Status: model.Status,
            SuspendedReasonCode: model.SuspendedReasonCode,
            TreatmentPlanId: model.TreatmentPlanId,
        };
        return result;
    };
    NHSComplexCarePathway_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ComplexCarepathwayType: model.ComplexCarepathwayType,
            ExpectedNumberOfClaims: model.ExpectedNumberOfClaims,
            IncompleteReasonCode: model.IncompleteReasonCode,
            LocationId: model.LocationId,
            NHSClaims: model.NHSClaims && model.NHSClaims.map(function (i) { return NHSClaim_1.NHSClaim_Factory.CreateOutgoing(i); }),
            NHSCourseDetail: NHSCourseDetail_1.NHSCourseDetail_Factory.CreateOutgoing(model.NHSCourseDetail),
            PatientId: model.PatientId,
            ProviderId: model.ProviderId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            Status: model.Status,
            SuspendedReasonCode: model.SuspendedReasonCode,
            TreatmentPlanId: model.TreatmentPlanId,
        };
        return result;
    };
    return NHSComplexCarePathway_Factory;
}());
exports.NHSComplexCarePathway_Factory = NHSComplexCarePathway_Factory;
